import {
  Baby, Waves, Umbrella, Camera, Home, Wrench, Smartphone, Mountain,
  Bike, Dumbbell, Music, Gamepad2, PartyPopper, Tent, Snowflake,
  Flower2, SprayCan, Luggage, PawPrint, Briefcase, Palette, Car,
  Shirt, Monitor, Heart, Scissors
} from "lucide-react";

export const CATEGORIES = [
  { name: "Baby & Kids", icon: Baby },
  { name: "Water Sports", icon: Waves },
  { name: "Beach Gear", icon: Umbrella },
  { name: "Photography & Video", icon: Camera },
  { name: "Household Appliances", icon: Home },
  { name: "Kitchen & Cooking", icon: Scissors },
  { name: "Tools & Power Equipment", icon: Wrench },
  { name: "Electronics & Gadgets", icon: Smartphone },
  { name: "Bikes & Scooters", icon: Bike },
  { name: "Sports & Recreation", icon: Dumbbell },
  { name: "Fitness & Exercise", icon: Heart },
  { name: "Musical Instruments", icon: Music },
  { name: "Gaming", icon: Gamepad2 },
  { name: "Party & Events", icon: PartyPopper },
  { name: "Camping & Hiking", icon: Tent },
  { name: "Winter Sports", icon: Snowflake },
  { name: "Garden & Lawn", icon: Flower2 },
  { name: "Cleaning Equipment", icon: SprayCan },
  { name: "Travel Gear", icon: Luggage },
  { name: "Pet Supplies", icon: PawPrint },
  { name: "Office & Work", icon: Monitor },
  { name: "Arts & Crafts", icon: Palette },
  { name: "Automotive", icon: Car },
  { name: "Fashion & Accessories", icon: Shirt },
  { name: "Medical & Mobility", icon: Briefcase },
  { name: "Outdoor & Adventure", icon: Mountain },
];

export const CARIBBEAN_LOCATIONS = [
  { name: "Cayman Islands", image: "https://images.unsplash.com/photo-1702743599501-a821d0b38b66?w=400" },
  { name: "Turks and Caicos", image: "https://images.unsplash.com/photo-1639222188528-3498adec4f40?w=400" },
  { name: "British Virgin Islands", image: "https://images.unsplash.com/photo-1604839379219-6871b4d4a4a5?w=400" },
  { name: "Bermuda", image: "https://images.unsplash.com/photo-1614632775489-812c1e992943?w=400" },
  { name: "St. Barts", image: "https://images.unsplash.com/photo-1651594861655-dfdf3e485552?w=400" },
  { name: "Aruba", image: "https://images.unsplash.com/photo-1682289571606-0736333cb3eb?w=400" },
  { name: "Barbados", image: "https://images.unsplash.com/photo-1767981235896-88d078d0c298?w=400" },
  { name: "Bahamas", image: "https://images.unsplash.com/photo-1760349212773-2a5508b12444?w=400" },
];

// Cayman Islands jurisdictions
export const CAYMAN_JURISDICTIONS = [
  { name: "Seven Mile Beach, Cayman Islands" },
  { name: "George Town, Cayman Islands" },
  { name: "West Bay, Cayman Islands" },
  { name: "South Sound, Cayman Islands" },
  { name: "Rum Point, Cayman Islands" },
  { name: "East End, Cayman Islands" },
  { name: "Savannah, Cayman Islands" },
  { name: "Red Bay, Cayman Islands" },
];

// US States with SEO-friendly slugs and major cities
// Priority states for MVP
export const US_STATES = {
  maine: {
    name: "Maine",
    abbrev: "ME",
    slug: "maine",
    cities: [
      { name: "Portland", slug: "portland" },
      { name: "Bangor", slug: "bangor" },
      { name: "Lewiston", slug: "lewiston" },
      { name: "Auburn", slug: "auburn" },
      { name: "South Portland", slug: "south-portland" },
      { name: "Augusta", slug: "augusta" },
      { name: "Biddeford", slug: "biddeford" },
      { name: "Brunswick", slug: "brunswick" },
    ]
  },
  massachusetts: {
    name: "Massachusetts",
    abbrev: "MA",
    slug: "massachusetts",
    cities: [
      { name: "Boston", slug: "boston" },
      { name: "Cambridge", slug: "cambridge" },
      { name: "Worcester", slug: "worcester" },
      { name: "Springfield", slug: "springfield" },
      { name: "Salem", slug: "salem" },
      { name: "Lowell", slug: "lowell" },
      { name: "Quincy", slug: "quincy" },
      { name: "Newton", slug: "newton" },
      { name: "Somerville", slug: "somerville" },
      { name: "Brookline", slug: "brookline" },
      { name: "Plymouth", slug: "plymouth" },
      { name: "Cape Cod", slug: "cape-cod" },
      { name: "Nantucket", slug: "nantucket" },
      { name: "Martha's Vineyard", slug: "marthas-vineyard" },
    ]
  },
  "rhode-island": {
    name: "Rhode Island",
    abbrev: "RI",
    slug: "rhode-island",
    cities: [
      { name: "Providence", slug: "providence" },
      { name: "Newport", slug: "newport" },
      { name: "Warwick", slug: "warwick" },
      { name: "Cranston", slug: "cranston" },
      { name: "Pawtucket", slug: "pawtucket" },
    ]
  },
  connecticut: {
    name: "Connecticut",
    abbrev: "CT",
    slug: "connecticut",
    cities: [
      { name: "Hartford", slug: "hartford" },
      { name: "New Haven", slug: "new-haven" },
      { name: "Stamford", slug: "stamford" },
      { name: "Bridgeport", slug: "bridgeport" },
      { name: "Waterbury", slug: "waterbury" },
      { name: "Norwalk", slug: "norwalk" },
      { name: "Greenwich", slug: "greenwich" },
      { name: "Danbury", slug: "danbury" },
      { name: "New Britain", slug: "new-britain" },
      { name: "West Hartford", slug: "west-hartford" },
    ]
  },
  "new-jersey": {
    name: "New Jersey",
    abbrev: "NJ",
    slug: "new-jersey",
    cities: [
      { name: "Newark", slug: "newark" },
      { name: "Jersey City", slug: "jersey-city" },
      { name: "Princeton", slug: "princeton" },
      { name: "Hoboken", slug: "hoboken" },
      { name: "Trenton", slug: "trenton" },
      { name: "Paterson", slug: "paterson" },
      { name: "Elizabeth", slug: "elizabeth" },
      { name: "Edison", slug: "edison" },
      { name: "Atlantic City", slug: "atlantic-city" },
      { name: "Cherry Hill", slug: "cherry-hill" },
      { name: "Morristown", slug: "morristown" },
      { name: "Red Bank", slug: "red-bank" },
    ]
  },
  "new-york": {
    name: "New York",
    abbrev: "NY",
    slug: "new-york",
    cities: [
      { name: "New York City", slug: "new-york-city" },
      { name: "Manhattan", slug: "manhattan" },
      { name: "Brooklyn", slug: "brooklyn" },
      { name: "Queens", slug: "queens" },
      { name: "Bronx", slug: "bronx" },
      { name: "Staten Island", slug: "staten-island" },
      { name: "Buffalo", slug: "buffalo" },
      { name: "Rochester", slug: "rochester" },
      { name: "Albany", slug: "albany" },
      { name: "Syracuse", slug: "syracuse" },
      { name: "Yonkers", slug: "yonkers" },
      { name: "White Plains", slug: "white-plains" },
      { name: "Long Island", slug: "long-island" },
      { name: "Hamptons", slug: "hamptons" },
      { name: "Ithaca", slug: "ithaca" },
    ]
  },
  pennsylvania: {
    name: "Pennsylvania",
    abbrev: "PA",
    slug: "pennsylvania",
    cities: [
      { name: "Philadelphia", slug: "philadelphia" },
      { name: "Pittsburgh", slug: "pittsburgh" },
      { name: "Harrisburg", slug: "harrisburg" },
      { name: "Allentown", slug: "allentown" },
      { name: "Erie", slug: "erie" },
      { name: "Reading", slug: "reading" },
      { name: "Scranton", slug: "scranton" },
      { name: "Bethlehem", slug: "bethlehem" },
      { name: "Lancaster", slug: "lancaster" },
      { name: "State College", slug: "state-college" },
    ]
  },
  delaware: {
    name: "Delaware",
    abbrev: "DE",
    slug: "delaware",
    cities: [
      { name: "Wilmington", slug: "wilmington" },
      { name: "Dover", slug: "dover" },
      { name: "Newark", slug: "newark" },
      { name: "Rehoboth Beach", slug: "rehoboth-beach" },
      { name: "Middletown", slug: "middletown" },
    ]
  },
  maryland: {
    name: "Maryland",
    abbrev: "MD",
    slug: "maryland",
    cities: [
      { name: "Baltimore", slug: "baltimore" },
      { name: "Bethesda", slug: "bethesda" },
      { name: "Annapolis", slug: "annapolis" },
      { name: "Rockville", slug: "rockville" },
      { name: "Silver Spring", slug: "silver-spring" },
      { name: "Frederick", slug: "frederick" },
      { name: "Gaithersburg", slug: "gaithersburg" },
      { name: "Columbia", slug: "columbia" },
      { name: "Ocean City", slug: "ocean-city" },
      { name: "Towson", slug: "towson" },
    ]
  },
  "washington-dc": {
    name: "Washington DC",
    abbrev: "DC",
    slug: "washington-dc",
    cities: [
      { name: "Capitol Hill", slug: "capitol-hill" },
      { name: "Georgetown", slug: "georgetown" },
      { name: "Dupont Circle", slug: "dupont-circle" },
      { name: "Adams Morgan", slug: "adams-morgan" },
    ]
  },
  virginia: {
    name: "Virginia",
    abbrev: "VA",
    slug: "virginia",
    cities: [
      { name: "Reston", slug: "reston" },
      { name: "Arlington", slug: "arlington" },
      { name: "Alexandria", slug: "alexandria" },
      { name: "Richmond", slug: "richmond" },
      { name: "Virginia Beach", slug: "virginia-beach" },
      { name: "Norfolk", slug: "norfolk" },
      { name: "Fairfax", slug: "fairfax" },
      { name: "Charlottesville", slug: "charlottesville" },
      { name: "McLean", slug: "mclean" },
      { name: "Tysons", slug: "tysons" },
      { name: "Falls Church", slug: "falls-church" },
      { name: "Herndon", slug: "herndon" },
      { name: "Ashburn", slug: "ashburn" },
      { name: "Leesburg", slug: "leesburg" },
    ]
  },
  "north-carolina": {
    name: "North Carolina",
    abbrev: "NC",
    slug: "north-carolina",
    cities: [
      { name: "Charlotte", slug: "charlotte" },
      { name: "Raleigh", slug: "raleigh" },
      { name: "Durham", slug: "durham" },
      { name: "Asheville", slug: "asheville" },
      { name: "Greensboro", slug: "greensboro" },
      { name: "Wilmington", slug: "wilmington" },
      { name: "Winston-Salem", slug: "winston-salem" },
      { name: "Chapel Hill", slug: "chapel-hill" },
      { name: "Cary", slug: "cary" },
      { name: "Outer Banks", slug: "outer-banks" },
    ]
  },
  "south-carolina": {
    name: "South Carolina",
    abbrev: "SC",
    slug: "south-carolina",
    cities: [
      { name: "Charleston", slug: "charleston" },
      { name: "Columbia", slug: "columbia" },
      { name: "Greenville", slug: "greenville" },
      { name: "Myrtle Beach", slug: "myrtle-beach" },
      { name: "Hilton Head", slug: "hilton-head" },
      { name: "Spartanburg", slug: "spartanburg" },
      { name: "Rock Hill", slug: "rock-hill" },
    ]
  },
  georgia: {
    name: "Georgia",
    abbrev: "GA",
    slug: "georgia",
    cities: [
      { name: "Atlanta", slug: "atlanta" },
      { name: "Savannah", slug: "savannah" },
      { name: "Augusta", slug: "augusta" },
      { name: "Athens", slug: "athens" },
      { name: "Marietta", slug: "marietta" },
      { name: "Sandy Springs", slug: "sandy-springs" },
      { name: "Roswell", slug: "roswell" },
      { name: "Alpharetta", slug: "alpharetta" },
      { name: "Decatur", slug: "decatur" },
      { name: "Buckhead", slug: "buckhead" },
    ]
  },
  florida: {
    name: "Florida",
    abbrev: "FL",
    slug: "florida",
    cities: [
      { name: "Miami", slug: "miami" },
      { name: "Miami Beach", slug: "miami-beach" },
      { name: "Orlando", slug: "orlando" },
      { name: "Tampa", slug: "tampa" },
      { name: "Jacksonville", slug: "jacksonville" },
      { name: "Fort Lauderdale", slug: "fort-lauderdale" },
      { name: "St. Petersburg", slug: "st-petersburg" },
      { name: "Naples", slug: "naples" },
      { name: "West Palm Beach", slug: "west-palm-beach" },
      { name: "Sarasota", slug: "sarasota" },
      { name: "Boca Raton", slug: "boca-raton" },
      { name: "Key West", slug: "key-west" },
      { name: "Fort Myers", slug: "fort-myers" },
      { name: "Clearwater", slug: "clearwater" },
      { name: "Gainesville", slug: "gainesville" },
      { name: "Tallahassee", slug: "tallahassee" },
      { name: "Palm Beach", slug: "palm-beach" },
      { name: "Destin", slug: "destin" },
      { name: "Panama City Beach", slug: "panama-city-beach" },
    ]
  },
  california: {
    name: "California",
    abbrev: "CA",
    slug: "california",
    cities: [
      { name: "Los Angeles", slug: "los-angeles" },
      { name: "San Francisco", slug: "san-francisco" },
      { name: "San Diego", slug: "san-diego" },
      { name: "San Jose", slug: "san-jose" },
      { name: "Sacramento", slug: "sacramento" },
      { name: "Oakland", slug: "oakland" },
      { name: "Irvine", slug: "irvine" },
      { name: "Santa Monica", slug: "santa-monica" },
      { name: "Pasadena", slug: "pasadena" },
      { name: "Long Beach", slug: "long-beach" },
      { name: "Fresno", slug: "fresno" },
      { name: "Bakersfield", slug: "bakersfield" },
      { name: "Santa Barbara", slug: "santa-barbara" },
      { name: "Palm Springs", slug: "palm-springs" },
      { name: "Beverly Hills", slug: "beverly-hills" },
      { name: "Palo Alto", slug: "palo-alto" },
      { name: "Berkeley", slug: "berkeley" },
      { name: "Newport Beach", slug: "newport-beach" },
      { name: "Laguna Beach", slug: "laguna-beach" },
      { name: "Malibu", slug: "malibu" },
      { name: "Napa", slug: "napa" },
      { name: "Sonoma", slug: "sonoma" },
      { name: "Carmel", slug: "carmel" },
      { name: "Monterey", slug: "monterey" },
    ]
  },
  washington: {
    name: "Washington",
    abbrev: "WA",
    slug: "washington",
    cities: [
      { name: "Seattle", slug: "seattle" },
      { name: "Spokane", slug: "spokane" },
      { name: "Tacoma", slug: "tacoma" },
      { name: "Bellevue", slug: "bellevue" },
      { name: "Olympia", slug: "olympia" },
      { name: "Kirkland", slug: "kirkland" },
      { name: "Redmond", slug: "redmond" },
      { name: "Vancouver", slug: "vancouver" },
      { name: "Everett", slug: "everett" },
      { name: "Bellingham", slug: "bellingham" },
    ]
  },
  ohio: {
    name: "Ohio",
    abbrev: "OH",
    slug: "ohio",
    cities: [
      { name: "Columbus", slug: "columbus" },
      { name: "Cleveland", slug: "cleveland" },
      { name: "Cincinnati", slug: "cincinnati" },
      { name: "Dayton", slug: "dayton" },
      { name: "Toledo", slug: "toledo" },
      { name: "Akron", slug: "akron" },
      { name: "Canton", slug: "canton" },
      { name: "Youngstown", slug: "youngstown" },
    ]
  },
  arizona: {
    name: "Arizona",
    abbrev: "AZ",
    slug: "arizona",
    cities: [
      { name: "Phoenix", slug: "phoenix" },
      { name: "Tucson", slug: "tucson" },
      { name: "Scottsdale", slug: "scottsdale" },
      { name: "Mesa", slug: "mesa" },
      { name: "Tempe", slug: "tempe" },
      { name: "Chandler", slug: "chandler" },
      { name: "Gilbert", slug: "gilbert" },
      { name: "Sedona", slug: "sedona" },
      { name: "Flagstaff", slug: "flagstaff" },
      { name: "Paradise Valley", slug: "paradise-valley" },
    ]
  },
  nevada: {
    name: "Nevada",
    abbrev: "NV",
    slug: "nevada",
    cities: [
      { name: "Las Vegas", slug: "las-vegas" },
      { name: "Reno", slug: "reno" },
      { name: "Henderson", slug: "henderson" },
      { name: "North Las Vegas", slug: "north-las-vegas" },
      { name: "Summerlin", slug: "summerlin" },
      { name: "Lake Tahoe", slug: "lake-tahoe" },
    ]
  },
  oregon: {
    name: "Oregon",
    abbrev: "OR",
    slug: "oregon",
    cities: [
      { name: "Portland", slug: "portland" },
      { name: "Eugene", slug: "eugene" },
      { name: "Salem", slug: "salem" },
      { name: "Bend", slug: "bend" },
      { name: "Beaverton", slug: "beaverton" },
      { name: "Medford", slug: "medford" },
      { name: "Ashland", slug: "ashland" },
      { name: "Lake Oswego", slug: "lake-oswego" },
    ]
  },
  michigan: {
    name: "Michigan",
    abbrev: "MI",
    slug: "michigan",
    cities: [
      { name: "Detroit", slug: "detroit" },
      { name: "Grand Rapids", slug: "grand-rapids" },
      { name: "Ann Arbor", slug: "ann-arbor" },
      { name: "Lansing", slug: "lansing" },
      { name: "Troy", slug: "troy" },
      { name: "Kalamazoo", slug: "kalamazoo" },
      { name: "Traverse City", slug: "traverse-city" },
      { name: "Royal Oak", slug: "royal-oak" },
      { name: "Birmingham", slug: "birmingham" },
    ]
  },
  illinois: {
    name: "Illinois",
    abbrev: "IL",
    slug: "illinois",
    cities: [
      { name: "Chicago", slug: "chicago" },
      { name: "Springfield", slug: "springfield" },
      { name: "Naperville", slug: "naperville" },
      { name: "Evanston", slug: "evanston" },
      { name: "Rockford", slug: "rockford" },
      { name: "Aurora", slug: "aurora" },
      { name: "Peoria", slug: "peoria" },
      { name: "Oak Park", slug: "oak-park" },
      { name: "Schaumburg", slug: "schaumburg" },
      { name: "Champaign", slug: "champaign" },
    ]
  },
  // Coming Soon States
  alabama: {
    name: "Alabama",
    abbrev: "AL",
    slug: "alabama",
    comingSoon: true,
    cities: [
      { name: "Birmingham", slug: "birmingham" },
      { name: "Montgomery", slug: "montgomery" },
      { name: "Huntsville", slug: "huntsville" },
      { name: "Mobile", slug: "mobile" },
      { name: "Tuscaloosa", slug: "tuscaloosa" },
    ]
  },
  alaska: {
    name: "Alaska",
    abbrev: "AK",
    slug: "alaska",
    comingSoon: true,
    cities: [
      { name: "Anchorage", slug: "anchorage" },
      { name: "Fairbanks", slug: "fairbanks" },
      { name: "Juneau", slug: "juneau" },
    ]
  },
  arkansas: {
    name: "Arkansas",
    abbrev: "AR",
    slug: "arkansas",
    comingSoon: true,
    cities: [
      { name: "Little Rock", slug: "little-rock" },
      { name: "Fayetteville", slug: "fayetteville" },
      { name: "Fort Smith", slug: "fort-smith" },
      { name: "Bentonville", slug: "bentonville" },
    ]
  },
  colorado: {
    name: "Colorado",
    abbrev: "CO",
    slug: "colorado",
    cities: [
      { name: "Denver", slug: "denver" },
      { name: "Colorado Springs", slug: "colorado-springs" },
      { name: "Boulder", slug: "boulder" },
      { name: "Fort Collins", slug: "fort-collins" },
      { name: "Aspen", slug: "aspen" },
      { name: "Vail", slug: "vail" },
      { name: "Aurora", slug: "aurora" },
      { name: "Lakewood", slug: "lakewood" },
      { name: "Breckenridge", slug: "breckenridge" },
      { name: "Telluride", slug: "telluride" },
    ]
  },
  hawaii: {
    name: "Hawaii",
    abbrev: "HI",
    slug: "hawaii",
    cities: [
      { name: "Honolulu", slug: "honolulu" },
      { name: "Maui", slug: "maui" },
      { name: "Kauai", slug: "kauai" },
      { name: "Big Island", slug: "big-island" },
      { name: "Waikiki", slug: "waikiki" },
      { name: "Lahaina", slug: "lahaina" },
      { name: "Kona", slug: "kona" },
      { name: "Hilo", slug: "hilo" },
      { name: "Kihei", slug: "kihei" },
      { name: "North Shore", slug: "north-shore" },
    ]
  },
  idaho: {
    name: "Idaho",
    abbrev: "ID",
    slug: "idaho",
    comingSoon: true,
    cities: [
      { name: "Boise", slug: "boise" },
      { name: "Idaho Falls", slug: "idaho-falls" },
      { name: "Coeur d'Alene", slug: "coeur-dalene" },
    ]
  },
  indiana: {
    name: "Indiana",
    abbrev: "IN",
    slug: "indiana",
    comingSoon: true,
    cities: [
      { name: "Indianapolis", slug: "indianapolis" },
      { name: "Fort Wayne", slug: "fort-wayne" },
      { name: "Bloomington", slug: "bloomington" },
      { name: "South Bend", slug: "south-bend" },
    ]
  },
  iowa: {
    name: "Iowa",
    abbrev: "IA",
    slug: "iowa",
    comingSoon: true,
    cities: [
      { name: "Des Moines", slug: "des-moines" },
      { name: "Cedar Rapids", slug: "cedar-rapids" },
      { name: "Iowa City", slug: "iowa-city" },
    ]
  },
  kansas: {
    name: "Kansas",
    abbrev: "KS",
    slug: "kansas",
    comingSoon: true,
    cities: [
      { name: "Wichita", slug: "wichita" },
      { name: "Kansas City", slug: "kansas-city" },
      { name: "Topeka", slug: "topeka" },
      { name: "Lawrence", slug: "lawrence" },
    ]
  },
  kentucky: {
    name: "Kentucky",
    abbrev: "KY",
    slug: "kentucky",
    comingSoon: true,
    cities: [
      { name: "Louisville", slug: "louisville" },
      { name: "Lexington", slug: "lexington" },
      { name: "Bowling Green", slug: "bowling-green" },
    ]
  },
  louisiana: {
    name: "Louisiana",
    abbrev: "LA",
    slug: "louisiana",
    comingSoon: true,
    cities: [
      { name: "New Orleans", slug: "new-orleans" },
      { name: "Baton Rouge", slug: "baton-rouge" },
      { name: "Shreveport", slug: "shreveport" },
      { name: "Lafayette", slug: "lafayette" },
    ]
  },
  minnesota: {
    name: "Minnesota",
    abbrev: "MN",
    slug: "minnesota",
    comingSoon: true,
    cities: [
      { name: "Minneapolis", slug: "minneapolis" },
      { name: "St. Paul", slug: "st-paul" },
      { name: "Rochester", slug: "rochester" },
      { name: "Duluth", slug: "duluth" },
    ]
  },
  mississippi: {
    name: "Mississippi",
    abbrev: "MS",
    slug: "mississippi",
    comingSoon: true,
    cities: [
      { name: "Jackson", slug: "jackson" },
      { name: "Gulfport", slug: "gulfport" },
      { name: "Biloxi", slug: "biloxi" },
    ]
  },
  missouri: {
    name: "Missouri",
    abbrev: "MO",
    slug: "missouri",
    comingSoon: true,
    cities: [
      { name: "Kansas City", slug: "kansas-city" },
      { name: "St. Louis", slug: "st-louis" },
      { name: "Springfield", slug: "springfield" },
      { name: "Columbia", slug: "columbia" },
    ]
  },
  montana: {
    name: "Montana",
    abbrev: "MT",
    slug: "montana",
    comingSoon: true,
    cities: [
      { name: "Billings", slug: "billings" },
      { name: "Missoula", slug: "missoula" },
      { name: "Bozeman", slug: "bozeman" },
    ]
  },
  nebraska: {
    name: "Nebraska",
    abbrev: "NE",
    slug: "nebraska",
    comingSoon: true,
    cities: [
      { name: "Omaha", slug: "omaha" },
      { name: "Lincoln", slug: "lincoln" },
    ]
  },
  "new-hampshire": {
    name: "New Hampshire",
    abbrev: "NH",
    slug: "new-hampshire",
    comingSoon: true,
    cities: [
      { name: "Manchester", slug: "manchester" },
      { name: "Nashua", slug: "nashua" },
      { name: "Concord", slug: "concord" },
      { name: "Portsmouth", slug: "portsmouth" },
    ]
  },
  "new-mexico": {
    name: "New Mexico",
    abbrev: "NM",
    slug: "new-mexico",
    comingSoon: true,
    cities: [
      { name: "Albuquerque", slug: "albuquerque" },
      { name: "Santa Fe", slug: "santa-fe" },
      { name: "Las Cruces", slug: "las-cruces" },
      { name: "Taos", slug: "taos" },
    ]
  },
  "north-dakota": {
    name: "North Dakota",
    abbrev: "ND",
    slug: "north-dakota",
    comingSoon: true,
    cities: [
      { name: "Fargo", slug: "fargo" },
      { name: "Bismarck", slug: "bismarck" },
    ]
  },
  oklahoma: {
    name: "Oklahoma",
    abbrev: "OK",
    slug: "oklahoma",
    comingSoon: true,
    cities: [
      { name: "Oklahoma City", slug: "oklahoma-city" },
      { name: "Tulsa", slug: "tulsa" },
      { name: "Norman", slug: "norman" },
    ]
  },
  "south-dakota": {
    name: "South Dakota",
    abbrev: "SD",
    slug: "south-dakota",
    comingSoon: true,
    cities: [
      { name: "Sioux Falls", slug: "sioux-falls" },
      { name: "Rapid City", slug: "rapid-city" },
    ]
  },
  tennessee: {
    name: "Tennessee",
    abbrev: "TN",
    slug: "tennessee",
    comingSoon: true,
    cities: [
      { name: "Nashville", slug: "nashville" },
      { name: "Memphis", slug: "memphis" },
      { name: "Knoxville", slug: "knoxville" },
      { name: "Chattanooga", slug: "chattanooga" },
    ]
  },
  texas: {
    name: "Texas",
    abbrev: "TX",
    slug: "texas",
    cities: [
      { name: "Houston", slug: "houston" },
      { name: "Dallas", slug: "dallas" },
      { name: "Austin", slug: "austin" },
      { name: "San Antonio", slug: "san-antonio" },
      { name: "Fort Worth", slug: "fort-worth" },
      { name: "El Paso", slug: "el-paso" },
      { name: "Plano", slug: "plano" },
      { name: "Frisco", slug: "frisco" },
      { name: "Arlington", slug: "arlington" },
      { name: "Irving", slug: "irving" },
      { name: "McKinney", slug: "mckinney" },
      { name: "Round Rock", slug: "round-rock" },
      { name: "The Woodlands", slug: "the-woodlands" },
      { name: "Sugar Land", slug: "sugar-land" },
    ]
  },
  utah: {
    name: "Utah",
    abbrev: "UT",
    slug: "utah",
    comingSoon: true,
    cities: [
      { name: "Salt Lake City", slug: "salt-lake-city" },
      { name: "Park City", slug: "park-city" },
      { name: "Provo", slug: "provo" },
      { name: "St. George", slug: "st-george" },
    ]
  },
  vermont: {
    name: "Vermont",
    abbrev: "VT",
    slug: "vermont",
    comingSoon: true,
    cities: [
      { name: "Burlington", slug: "burlington" },
      { name: "Montpelier", slug: "montpelier" },
      { name: "Stowe", slug: "stowe" },
    ]
  },
  "west-virginia": {
    name: "West Virginia",
    abbrev: "WV",
    slug: "west-virginia",
    comingSoon: true,
    cities: [
      { name: "Charleston", slug: "charleston" },
      { name: "Morgantown", slug: "morgantown" },
      { name: "Huntington", slug: "huntington" },
    ]
  },
  wisconsin: {
    name: "Wisconsin",
    abbrev: "WI",
    slug: "wisconsin",
    comingSoon: true,
    cities: [
      { name: "Milwaukee", slug: "milwaukee" },
      { name: "Madison", slug: "madison" },
      { name: "Green Bay", slug: "green-bay" },
    ]
  },
  wyoming: {
    name: "Wyoming",
    abbrev: "WY",
    slug: "wyoming",
    comingSoon: true,
    cities: [
      { name: "Cheyenne", slug: "cheyenne" },
      { name: "Jackson", slug: "jackson" },
      { name: "Casper", slug: "casper" },
    ]
  },
};

// Generate flat US_LOCATIONS array for backward compatibility
export const US_LOCATIONS = Object.values(US_STATES).flatMap(state => 
  state.cities.map(city => ({
    name: `${city.name}, ${state.abbrev}`,
    cityName: city.name,
    citySlug: city.slug,
    stateSlug: state.slug,
    stateName: state.name,
    stateAbbrev: state.abbrev,
  }))
);

export const ALL_LOCATIONS = [
  ...CARIBBEAN_LOCATIONS.map((l) => ({ ...l, type: "caribbean" })),
  ...CAYMAN_JURISDICTIONS.map((l) => ({ ...l, type: "caribbean" })),
  ...US_LOCATIONS.map((l) => ({ ...l, type: "us" })),
];

// SEO slug helpers
export function locationToSlug(name) {
  return name
    .toLowerCase()
    .replace(/\./g, "")
    .replace(/[,\s]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/-$/, "");
}

// Get location by state and city slugs
export function getLocationByStateCity(stateSlug, citySlug) {
  const state = US_STATES[stateSlug];
  if (!state) return null;
  const city = state.cities.find(c => c.slug === citySlug);
  if (!city) return null;
  return {
    name: `${city.name}, ${state.abbrev}`,
    cityName: city.name,
    citySlug: city.slug,
    stateSlug: state.slug,
    stateName: state.name,
    stateAbbrev: state.abbrev,
    type: "us"
  };
}

// Get state by slug
export function getStateBySlug(stateSlug) {
  return US_STATES[stateSlug] || null;
}

// Get Caribbean location by slug
export function getCaribbeanBySlug(slug) {
  const allCaribbean = [...CARIBBEAN_LOCATIONS, ...CAYMAN_JURISDICTIONS];
  return allCaribbean.find(loc => locationToSlug(loc.name) === slug);
}

export function getLocationBySlug(slug) {
  // First check Caribbean
  const caribbean = getCaribbeanBySlug(slug);
  if (caribbean) return { ...caribbean, type: "caribbean" };
  
  // Then check if it's a state slug
  const state = getStateBySlug(slug);
  if (state) return { ...state, type: "state" };
  
  // Fallback to old behavior
  return ALL_LOCATIONS.find((loc) => locationToSlug(loc.name) === slug);
}

// Pre-built slug map for quick lookup - Caribbean locations only
// US cities should be accessed via canonical /:state/:city URLs, not /:city-state
export const LOCATION_SLUG_MAP = Object.fromEntries(
  [...CARIBBEAN_LOCATIONS, ...CAYMAN_JURISDICTIONS].map((loc) => [locationToSlug(loc.name), { ...loc, type: "caribbean" }])
);

// Add states to slug map (for state landing pages like /virginia, /california)
Object.values(US_STATES).forEach(state => {
  LOCATION_SLUG_MAP[state.slug] = { ...state, type: "state" };
});

// Build redirect map for old-format US city URLs (e.g., /reston-va -> /virginia/reston)
// This is for SEO - we want to 301 redirect old URLs to the canonical format
export const US_CITY_REDIRECT_MAP = {};
Object.values(US_STATES).forEach(state => {
  state.cities.forEach(city => {
    // Old format: city-stateabbrev (e.g., "reston-va")
    const oldSlug = `${city.slug}-${state.abbrev.toLowerCase()}`;
    // Also handle "cityname-stateabbrev" format
    const oldSlug2 = locationToSlug(`${city.name}, ${state.abbrev}`);
    
    US_CITY_REDIRECT_MAP[oldSlug] = `/${state.slug}/${city.slug}`;
    US_CITY_REDIRECT_MAP[oldSlug2] = `/${state.slug}/${city.slug}`;
  });
});

// Function to check if a slug needs a redirect and return the canonical URL
export function getUSCityRedirect(slug) {
  return US_CITY_REDIRECT_MAP[slug] || null;
}
